import * as React from 'react';

import { WishlistPager } from './components/WishlistPager';
import { trackWishlistPageView } from './components/WishlistPager/tracking';
import { PRODUCTS_PER_PAGE } from './constants';
import { WishlistContainer, LoadingContainer } from './styled';
import { useWishlistForLoggedUserOrOwner } from './useWishlistForLoggedUserOrOwner';

export interface WishlistProps {
  data?: {
    owner?: string; // if wishlist id ('owner') is not provided, logged user's wishlist is fetched
  };
}

const WishList: React.FC<WishlistProps> = ({ data }) => {
  const { productIds, loading, owner, userId } =
    useWishlistForLoggedUserOrOwner(data?.owner);

  React.useEffect(() => {
    trackWishlistPageView();
  }, []);

  return (
    <WishlistContainer>
      {loading ? (
        <LoadingContainer />
      ) : (
        <WishlistPager
          pageSize={PRODUCTS_PER_PAGE}
          owner={owner}
          productIds={productIds}
          userId={userId}
        />
      )}
    </WishlistContainer>
  );
};

export default WishList;
